import { render, staticRenderFns } from "./Mgc.vue?vue&type=template&id=f6705dac&scoped=true&"
import script from "./Mgc.vue?vue&type=script&lang=js&"
export * from "./Mgc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6705dac",
  null
  
)

export default component.exports